// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"278":"polyfills-dom","329":"polyfills-core-js"}[chunkId] || chunkId) + "." + {"278":"2b470796","329":"72ad45f7","917":"ccb8a1b9"}[chunkId] + ".chunk.js";
};